import { BiChevronLeft } from "react-icons/bi";
import Button from "shared/components/Button";
import Card from "shared/components/Card";

const StepCard = ({ title, description, onBack, backLabel, actions, children }) => (
  <Card type="simple">
    {(title || onBack) && (
      <div className="pricers-import__card-header">
        <div>
          {title && <h3 className="pricers-import__card-title">{title}</h3>}
          {description && (
            <p className="pricers-import__card-description">{description}</p>
          )}
        </div>
        {onBack && (
          <Button type="primary--outlined" onClick={onBack}>
            <BiChevronLeft size={18} />
            {backLabel}
          </Button>
        )}
      </div>
    )}
    <div className="pricers-import__card-body">{children}</div>
    {actions && (
      <div className="pricers-import__card-actions">{actions}</div>
    )}
  </Card>
);

export default StepCard;
